<template>
  <div>
    <Breadcrumb v-if="!$route.path.includes('list')" :options="breadcrumb" />
    
    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">增值税发票开票信息</div>
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>

        <div class="block">
          <div class="contit">收票人信息</div>
          <FormItem v-for="(c, i) in formCtrl1" :key="'formItem' + i" :viewMode="c.viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'kai'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'custom',
      getDataUrl: 'getBilling',
      submitUrl: 'editBilling',
      form: {
        qy_name: undefined,
        taxpayer_num: undefined,
      },
      breadcrumb: [
        { name: "客户管理", path: `/customer/manage` },
        { name: "客户列表", path: `/customer/manage` },
        { name: "发票管理" },
      ],
      rules: {
        qy_name: [
          { required: true, message: "请填写企业名称", trigger: "blur" },
        ],
        taxpayer_num: [
          { required: true, message: "请填写统一社会信用代码", trigger: "blur" },
        ],
        // taxpayer_num: [
        //   { required: true, message: "请填写统一社会信用代码", trigger: "blur" },
        // ],
      },
      formCtrl: [
        {
          label: "发票类型",
          keyName: "invoice_type",
          err: "请选择发票类型",
          type: "select",
          options: [
            {
              label: "增值税普通发票",
              value: "增值税普通发票",
            },
            {
              label: "增值税专用发票",
              value: "增值税专用发票",
            },
          ],
        },
        {
          label: "企业类型",
          keyName: "qy_type",
          err: "请选择企业类型",
          type: "select",
          options: [
            {
              label: "小规模纳税人",
              value: "小规模纳税人",
            },
            {
              label: "一般纳税人",
              value: "一般纳税人",
            },
          ],
        },
        {
          label: "企业名称",
          keyName: "qy_name",
          err: "请填写企业名称",
          type: "text",
        },
        {
          label: "统一社会信用代码",
          keyName: "taxpayer_num",
          err: "请填写统一社会信用代码",
          type: "text",
        },
        {
          label: "注册地址",
          keyName: "zc_address",
          err: "请填写注册地址",
          type: "text",
        },
        {
          label: "注册电话",
          keyName: "zc_phone",
          err: "请填写注册电话",
          type: "text",
        },
        {
          label: "开户银行",
          keyName: "opening_bank",
          err: "请填写开户银行",
          type: "text",
        },
        {
          label: "银行账号",
          keyName: "bank_card",
          err: "请填写银行账号",
          type: "number",
        },
      ],
      formCtrl1: [
        {
          label: "收票人姓名",
          keyName: "sp_name",
          err: "请填写收票人姓名",
          type: "text",
        },
        {
          label: "收票人联系电话",
          keyName: "sp_phone",
          err: "请填写收票人联系电话",
          type: "number",
        },
        {
          label: "收票人电子邮箱",
          keyName: "sp_email",
          err: "请填写收票人电子邮箱",
          type: "text",
        },
        {
          label: "收票地址",
          keyName: "sp_address",
          err: "请填写收票地址",
          type: "text",
        },
      ],
      // getOptionUrl: 'index',
    };
  },
  methods: {
    submitReq() {
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        ...this.form,
        id: this.id
      }

      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getOptions()
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 400px;
      }

      .el-form-item__content {
        .el-input {
          width: 400px;
        }

        .unit {
          color: #909399;
        }

      }

    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}


.btns {
  margin: 40px 0 60px 180px;
}
</style>
